module.exports = __webpack_public_path__ + "static/media/pastas.f7a659b4.jpg";